/* eslint-disable */
require('./back')
require('./down')
require('./elevator')
require('./exit')
require('./finish')
require('./forward')
require('./in')
require('./straight-portal')
require('./left')
require('./out')
require('./right')
require('./straight')
require('./turn-around')
require('./up')
